import { Controller } from "@hotwired/stimulus"

// Gates a destructive form's submit button behind typing an exact
// confirmation phrase (e.g. the marketplace's own name) -- a client-side
// nicety only. The real boundary is server-side (the controller re-checks
// the submitted value itself), since a disabled button is trivially
// bypassed from devtools.
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  connect() {
    this.update()
  }

  update() {
    this.submitTarget.disabled = this.inputTarget.value !== this.expectedValue
  }
}
